"use client";

import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        {[...Array(6)].map((_, i) => <div key={i} className="h-5 w-24 bg-white/20 animate-pulse rounded" />)}
      </div>;
  }
  return <nav className="flex gap-6">
      {menuItems.slice(0, 5).map((item, i) => <Link key={`${item.id}-${i}`} to={item.href || "#"} data-index={i} className="text-sm text-white hover:text-[#2EAF7D] relative inline-block after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[1px] after:bg-white after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
          {item.label}
        </Link>)}
      <Link to="/PrivacyPolicyPage" className="text-sm text-white hover:text-[#2EAF7D] relative inline-block after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[1px] after:bg-white after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
        Privacy Policy
      </Link>
      <Link to="/AboutPage" className="text-sm text-white hover:text-[#2EAF7D] relative inline-block after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[1px] after:bg-white after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
        About
      </Link>
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <footer ref={ref} className={`w-full bg-black text-white py-12 px-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
        {}
        <div className="flex flex-col gap-2">
          <p className="text-sm">© 2026 Bozang Digital</p>
        </div>

        {}
        <div className="flex justify-center">
          <MenuProvider menu_id="4">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="flex justify-end">
          <Link to="https://www.linkedin.com/in/marissa-greever-ab8b70282/" newTab className="text-white hover:text-[#2EAF7D] transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:scale-[1.05]" aria-label="LinkedIn">
            <Linkedin className="size-5" />
          </Link>
        </div>
      </div>
    </footer>;
}